import Utility from './Utility'

export default Utility
